<template lang="pug">
  e-form-group(
  :name="fieldName"
  inputType="select"
  label="Год"
    :model="fields"
      :options="options"
      :tabView="tabView"
      :formGroupStyle="formGroupStyle"
      :required="required"
  )
</template>
<script>
import yearHelper from '@/utils/year'
import reportFieldMixin from '../../mixins/report-field-mixin'

export default {
  name: 'year',
  mixins: [reportFieldMixin],
  computed: {
    fieldName() {
      if (this.name) {
        return this.name
      }
      return 'year'
    },
    options() {
      return yearHelper.getYearsOptions()
    },
  },
  created() {
    this.$set(this.fields, this.fieldName, yearHelper.getCurrentYear() - 1)
  },
}
</script>
